import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { PushNotificationService } from './services/push-notification.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faTriangleExclamation,
  faXmark,
} from '@fortawesome/pro-duotone-svg-icons';

@Component({
  selector: 'app-push-notification',
  imports: [FontAwesomeModule],
  templateUrl: './push-notification.html',
  styleUrl: './push-notification.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PushNotification {
  private readonly notificationService = inject(PushNotificationService);

  notifications = this.notificationService.notifications;

  // Icons
  icons = {
    success: faCircleCheck,
    error: faCircleExclamation,
    warning: faTriangleExclamation,
    info: faCircleInfo,
    close: faXmark,
  };

  getIcon(type: 'success' | 'error' | 'warning' | 'info') {
    return this.icons[type];
  }

  close(id: string) {
    this.notificationService.remove(id);
  }
}

